import { useMemo } from 'react';
import { useProject } from './api-hooks/useProject';

/** @returns if current user is super user */
export const useIsPermissionManager = () => {
  const project = useProject({ enabled: false });

  const isPermissionManager = useMemo(
    () => !!project.data?.is_permission_manager,
    [project]
  );
  return isPermissionManager;
};
